(() => {
  const markers = '[data-lny-romantic-compact]';
  const fields = 'textarea[name="properties[Arka Yüz Yazısı]"],textarea[name="properties[Kişiselleştirme Notu]"]';
  function fit(field) {
    if (!(field instanceof HTMLTextAreaElement) || !field.getClientRects().length) return;
    field.rows = 1;
    field.style.height = 'auto';
    const style = getComputedStyle(field);
    const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    field.style.height = `${Math.max(44, Math.ceil(field.scrollHeight + border))}px`;
    const heading = field.closest('product-custom-property-component')?.querySelector('.__heading');
    if (heading && !field.hasAttribute('aria-label')) field.setAttribute('aria-label', heading.textContent.trim());
  }
  function enhance(marker) {
    const root = marker.closest('.shopify-section');
    if (!root || root.dataset.lnyCompactReady) return;
    root.dataset.lnyCompactReady = 'true';
    root.classList.add('lny-romantic-compact');
    const fitAll = () => root.querySelectorAll(fields).forEach(fit);
    root.addEventListener('input', event => { if (event.target.matches?.(fields)) fit(event.target); });
    root.addEventListener('toggle', () => requestAnimationFrame(fitAll), true);
    window.addEventListener('resize', () => requestAnimationFrame(fitAll), { passive: true });
    fitAll();
    document.fonts?.ready.then(fitAll);
  }
  const init = () => document.querySelectorAll(markers).forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
